import React from 'react';
import { Box, Typography } from '@mui/material';
import { LockOutlined as AnonymousIcon } from '@mui/icons-material';

export const AnonymousNotice: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      px: 1.5,
      py: 1,
      borderRadius: 1,
      bgcolor: 'info.light',
      color: 'info.contrastText',
      opacity: 0.85,
    }}
  >
    <AnonymousIcon fontSize="small" />
    <Typography variant="caption" fontWeight={500}>
      Your feedback is anonymous — the colleague won't know who submitted it.
    </Typography>
  </Box>
);
